export const mediaItems = [
  {
    id: 'media-1',
    title: '随时随地·畅快阅读',
    desc: '手机、平板、电脑全平台适配，无缝切换阅读进度，地铁上、午休时、睡前时光，咻咻漫画陪你度过每一段碎片时间。',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20scene%20of%20a%20person%20reading%20colorful%20digital%20comics%20on%20a%20tablet%20in%20a%20warm%20cafe%20with%20soft%20ambient%20lighting%20stylized%20manga%20panels%20floating%20subtly%20in%20the%20background%20modern%20minimal%20interior%20with%20wooden%20table%20and%20green%20plant%20warm%20coral%20and%20cream%20color%20palette%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%20cozy%20atmosphere&width=800&height=450&seq=manga-media-01&orientation=landscape',
    icon: 'ri-smartphone-line',
    tag: '全平台',
  },
  {
    id: 'media-2',
    title: '海量全集·一次看够',
    desc: '收录超过10000部完结漫画，韩漫国漫日漫全覆盖，不再忍受每周等一话的煎熬，打开即看全集，从第一话刷到大结局。',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20digital%20library%20of%20colorful%20comic%20books%20and%20manga%20volumes%20arranged%20on%20floating%20shelves%20in%20a%20warm%20lit%20modern%20space%20with%20soft%20golden%20light%20streaming%20through%20large%20windows%20artistic%20illustration%20style%20with%20vibrant%20cover%20art%20warm%20amber%20and%20cream%20tones%20rich%20detailed%20composition%20inviting%20atmosphere&width=800&height=450&seq=manga-media-02&orientation=landscape',
    icon: 'ri-stack-line',
    tag: '海量资源',
  },
  {
    id: 'media-3',
    title: '下拉畅读·沉浸体验',
    desc: '独家下拉式阅读模式，页面流畅衔接，无需翻页点击，像刷视频一样轻松看漫画，给你前所未有的沉浸式追漫体验。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20closeup%20of%20a%20smartphone%20screen%20displaying%20a%20vertically%20scrolling%20webtoon%20style%20comic%20with%20vibrant%20colors%20and%20dynamic%20panels%20the%20phone%20rests%20on%20a%20wooden%20desk%20next%20to%20a%20warm%20cup%20of%20coffee%20soft%20natural%20light%20streaming%20in%20from%20the%20side%20cozy%20home%20setting%20with%20bokeh%20background%20warm%20coral%20and%20cream%20tones&width=800&height=450&seq=manga-media-03&orientation=landscape',
    icon: 'ri-scroll-to-bottom-line',
    tag: '下拉阅读',
  },
];

export const indexItems = [
  {
    id: 'idx-1',
    title: '韩漫全集',
    desc: '完结韩漫一网打尽',
    count: '3280+部',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20style%20romance%20manhwa%20cover%20art%20with%20soft%20pastel%20colors%20elegant%20character%20design%20delicate%20linework%20and%20dreamy%20atmosphere%20floral%20elements%20and%20gentle%20lighting%20modern%20webtoon%20aesthetic%20warm%20pink%20and%20cream%20tones%20clean%20composition%20on%20simple%20background&width=400&height=300&seq=manga-idx-01&orientation=landscape',
    color: 'bg-primary-50',
  },
  {
    id: 'idx-2',
    title: '国漫精选',
    desc: '精品国漫持续收录',
    count: '2560+部',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20style%20cover%20art%20featuring%20martial%20arts%20fantasy%20theme%20with%20flowing%20ink%20brush%20effects%20vibrant%20red%20and%20gold%20accents%20traditional%20Chinese%20elements%20blended%20with%20modern%20comic%20style%20dramatic%20composition%20rich%20textures%20clean%20background&width=400&height=300&seq=manga-idx-02&orientation=landscape',
    color: 'bg-accent-50',
  },
  {
    id: 'idx-3',
    title: '日漫经典',
    desc: '完结日漫全收藏',
    count: '4520+部',
    image: 'https://readdy.ai/api/search-image?query=A%20classic%20Japanese%20manga%20style%20cover%20art%20with%20bold%20black%20and%20white%20contrast%20dynamic%20action%20pose%20expressive%20character%20design%20speed%20lines%20and%20dramatic%20shading%20warm%20sepia%20undertones%20vintage%20comic%20feel%20clean%20cream%20background%20professional%20illustration&width=400&height=300&seq=manga-idx-03&orientation=landscape',
    color: 'bg-secondary-50',
  },
  {
    id: 'idx-4',
    title: '热血冒险',
    desc: '燃到停不下来',
    count: '1890+部',
    image: 'https://readdy.ai/api/search-image?query=An%20action%20packed%20adventure%20manga%20style%20cover%20with%20dynamic%20characters%20in%20motion%20epic%20battle%20scene%20silhouette%20vibrant%20orange%20and%20warm%20red%20energy%20effects%20dramatic%20lighting%20speed%20lines%20powerful%20composition%20professional%20comic%20art%20on%20clean%20background&width=400&height=300&seq=manga-idx-04&orientation=landscape',
    color: 'bg-primary-50',
  },
  {
    id: 'idx-5',
    title: '恋爱甜宠',
    desc: '甜蜜心动的故事',
    count: '2150+部',
    image: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20manga%20style%20cover%20art%20featuring%20two%20characters%20in%20a%20tender%20moment%20soft%20pastel%20pink%20and%20warm%20peach%20color%20palette%20floating%20cherry%20blossom%20petals%20gentle%20spring%20lighting%20delicate%20linework%20dreamy%20atmosphere%20clean%20cream%20background&width=400&height=300&seq=manga-idx-05&orientation=landscape',
    color: 'bg-accent-50',
  },
  {
    id: 'idx-6',
    title: '悬疑推理',
    desc: '烧脑反转不停歇',
    count: '960+部',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20manga%20cover%20art%20with%20dark%20atmospheric%20mood%20silhouetted%20figure%20in%20a%20dimly%20lit%20alleyway%20warm%20amber%20streetlight%20glow%20noir%20detective%20vibe%20dramatic%20shadows%20and%20high%20contrast%20professional%20comic%20illustration%20on%20clean%20background&width=400&height=300&seq=manga-idx-06&orientation=landscape',
    color: 'bg-secondary-50',
  },
  {
    id: 'idx-7',
    title: '奇幻异界',
    desc: '异世界穿越之旅',
    count: '1430+部',
    image: 'https://readdy.ai/api/search-image?query=A%20fantasy%20isekai%20manga%20cover%20art%20featuring%20a%20magical%20portal%20and%20fantasy%20creatures%20in%20a%20vibrant%20otherworldly%20landscape%20warm%20golden%20and%20emerald%20color%20palette%20floating%20crystals%20and%20sparkles%20epic%20fantasy%20atmosphere%20professional%20illustration%20on%20clean%20background&width=400&height=300&seq=manga-idx-07&orientation=landscape',
    color: 'bg-primary-50',
  },
  {
    id: 'idx-8',
    title: '都市生活',
    desc: '贴近生活的故事',
    count: '1080+部',
    image: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20manga%20cover%20art%20depicting%20everyday%20urban%20scene%20with%20characters%20in%20modern%20city%20setting%20warm%20sunset%20lighting%20cozy%20atmosphere%20casual%20modern%20fashion%20soft%20natural%20color%20palette%20relaxed%20composition%20professional%20comic%20art%20on%20clean%20background&width=400&height=300&seq=manga-idx-08&orientation=landscape',
    color: 'bg-accent-50',
  },
];

export const appData = {
  title: '咻咻漫画 APP',
  subtitle: '移动端专属下拉式阅读体验',
  desc: '专为手机优化的漫画阅读器，流畅下拉、智能预加载、夜间模式、离线缓存。现已支持 iOS 与 Android 双平台，随时随地畅享全集漫画。',
  features: ['下拉畅读', '夜间模式', '离线缓存', '进度同步', '推送提醒', '高清画质'],
  image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20modern%20smartphone%20mockup%20displaying%20a%20colorful%20webtoon%20comic%20on%20screen%20with%20vibrant%20illustrations%20the%20phone%20floats%20elegantly%20against%20a%20warm%20gradient%20background%20of%20coral%20and%20cream%20tones%20clean%20product%20presentation%20style%20with%20soft%20lighting%20and%20subtle%20reflections%20premium%20look&width=600&height=800&seq=manga-app-01&orientation=portrait',
};

export const aboutData = {
  title: '关于咻咻漫画',
  paragraphs: [
    '咻咻漫画创立于2024年，是国内领先的全集漫画一站式阅读平台。我们专注于为漫画爱好者提供高品质、正版授权的完结漫画资源，让每一位读者都能享受"打开即全集、下拉即畅读"的极致体验。',
    '平台目前已收录超过17000部完结漫画作品，涵盖韩漫、国漫、日漫三大品类，覆盖热血、恋爱、悬疑、奇幻、都市等十余个题材分类，日均更新话数超过50话，持续为读者带来新鲜内容。',
    '我们坚持免费阅读的核心理念，通过独创的下拉式阅读技术和智能推荐算法，让每一位漫画爱好者都能在这里找到属于自己的阅读节奏。从经典老番到最新完结，从热门韩漫到精品国漫，咻咻漫画致力于成为你最值得信赖的漫画阅读伙伴。',
  ],
  stats: [
    { value: '17,000+', label: '完结作品' },
    { value: '50+', label: '日均更新话数' },
    { value: '3,200万+', label: '月活读者' },
    { value: '99.2%', label: '读者好评率' },
  ],
  image: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20modern%20reading%20space%20with%20a%20large%20digital%20screen%20displaying%20colorful%20comic%20art%20surrounded%20by%20cozy%20seating%20and%20bookshelves%20filled%20with%20manga%20volumes%20soft%20natural%20light%20streaming%20through%20windows%20warm%20coral%20and%20cream%20interior%20design%20friendly%20community%20atmosphere%20editorial%20photography%20style&width=800&height=500&seq=manga-about-01&orientation=landscape',
};

export const faqItems = [
  {
    id: 'faq-1',
    question: '咻咻漫画是免费的吗？所有漫画都可以免费看吗？',
    answer: '是的！咻咻漫画平台上所有漫画均为免费阅读，我们坚持"全集免费"的核心理念，无论是韩漫全集、国漫全集还是日漫经典作品，全部开放免费畅读，无需付费订阅，也没有隐藏收费项目。',
  },
  {
    id: 'faq-2',
    question: '什么是"下拉式阅读"？和传统翻页有什么区别？',
    answer: '下拉式阅读是我们独创的漫画浏览方式——所有话数在同一个页面内纵向无缝衔接，读者只需向下滑动即可连续阅读，无需点击"下一话"按钮，也不用等待页面加载。就像刷短视频一样流畅自然，彻底告别传统漫画阅读的"翻页断档"体验。',
  },
  {
    id: 'faq-3',
    question: '平台上的漫画有更新吗？完结漫画还会新增吗？',
    answer: '当然！我们每天都会新增和补充漫画资源，日均有超过50话内容入库。除了持续收录最新完结的韩漫和国漫作品外，我们也在不断补全经典日漫的全集资源。建议关注首页"更新快讯"板块，第一时间获取上新通知。',
  },
  {
    id: 'faq-4',
    question: '支持哪些设备阅读？需要下载APP吗？',
    answer: '咻咻漫画支持手机、平板和电脑多端访问，网页版即开即用无需下载。如果你想获得更流畅的离线阅读体验，也可以下载我们的移动端APP（支持iOS和Android），享受夜间模式、离线缓存和推送提醒等专属功能。',
  },
  {
    id: 'faq-5',
    question: '漫画的画质怎么样？加载速度快吗？',
    answer: '所有漫画均采用高清源文件处理，画面清晰锐利，细节表现力出色。我们部署了智能CDN加速和图片预加载技术，确保即使在移动网络下也能快速加载，下拉阅读过程中画面无缝衔接，给你丝滑流畅的阅读体验。',
  },
];

export const carouselItems = [
  {
    id: 'car-1',
    title: '韩漫完结季',
    subtitle: '百部热门韩漫全集一次收齐',
    desc: '精选100部高人气完结韩漫，从甜宠恋爱到悬疑推理，从古风宫廷到现代都市，全品类覆盖，全部免费下拉畅读，这个夏天一口气刷完。',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20style%20illustration%20featuring%20elegant%20characters%20in%20traditional%20and%20modern%20fusion%20costumes%20surrounded%20by%20floating%20flower%20petals%20and%20soft%20magical%20glow%20warm%20coral%20and%20gold%20color%20palette%20dreamy%20romantic%20atmosphere%20professional%20manhwa%20art%20style&width=600&height=400&seq=manga-car-01&orientation=landscape',
    tag: '热门推荐',
    color: 'bg-primary-50',
  },
  {
    id: 'car-2',
    title: '国漫崛起',
    subtitle: '精品国产漫画全集大赏',
    desc: '国漫精品持续收录中！玄幻修仙、都市异能、古风言情……各类爆款国漫全集已就位，支持国产漫画，从这里开始。',
    image: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Chinese%20manhua%20style%20artwork%20depicting%20a%20mythical%20celestial%20palace%20floating%20among%20clouds%20with%20dynamic%20martial%20arts%20characters%20in%20flowing%20silk%20robes%20vibrant%20red%20gold%20and%20jade%20green%20color%20palette%20epic%20fantasy%20atmosphere%20professional%20illustration&width=600&height=400&seq=manga-car-02&orientation=landscape',
    tag: '编辑精选',
    color: 'bg-accent-50',
  },
  {
    id: 'car-3',
    title: '日漫经典馆',
    subtitle: '重温那些年追过的经典',
    desc: '从热血少年漫到治愈系日常，从悬疑神作到恋爱经典，日漫完结佳作全集收录。那些年你追过的、错过的、想重刷的，这里都有。',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Japanese%20manga%20style%20illustration%20with%20classic%20shonen%20aesthetic%20dynamic%20characters%20in%20action%20poses%20bold%20linework%20and%20dramatic%20shading%20warm%20sepia%20and%20cream%20color%20palette%20retro%20comic%20feel%20with%20modern%20polish%20professional%20manga%20art&width=600&height=400&seq=manga-car-03&orientation=landscape',
    tag: '经典回顾',
    color: 'bg-secondary-50',
  },
  {
    id: 'car-4',
    title: '新完结速递',
    subtitle: '本周最新完结作品一览',
    desc: '实时追踪各大平台最新完结动态，第一时间上架全集资源。不再忍受追更之苦，完结即入库，打开就看全集，永远快人一步。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20vibrant%20comic%20style%20illustration%20showing%20a%20dynamic%20storytelling%20scene%20with%20multiple%20panels%20merging%20together%20vivid%20colors%20and%20energetic%20composition%20fresh%20contemporary%20manga%20aesthetic%20warm%20coral%20and%20amber%20accents%20exciting%20atmosphere%20professional%20digital%20art&width=600&height=400&seq=manga-car-04&orientation=landscape',
    tag: '最新收录',
    color: 'bg-primary-50',
  },
  {
    id: 'car-5',
    title: '冷门佳作发掘',
    subtitle: '那些被低估的宝藏漫画',
    desc: '编辑团队精心筛选，每月推荐一批口碑出色但关注度不高的完结佳作。好故事不该被埋没，来发现属于你的下一部神作。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20captivating%20manga%20style%20illustration%20with%20a%20hidden%20gem%20treasure%20theme%20glowing%20books%20and%20scrolls%20emerging%20from%20shadows%20warm%20golden%20light%20illuminating%20ancient%20comic%20panels%20discovery%20and%20wonder%20atmosphere%20rich%20amber%20and%20cream%20tones%20professional%20art&width=600&height=400&seq=manga-car-05&orientation=landscape',
    tag: '冷门推荐',
    color: 'bg-accent-50',
  },
];

export const rankingItems = [
  { id: 'rk-1', rank: 1, title: '我的野蛮王妃', category: '韩漫·恋爱', heat: '982万', tag: 'HOT', tagColor: 'bg-primary-500' },
  { id: 'rk-2', rank: 2, title: '斗罗大陆', category: '国漫·玄幻', heat: '956万', tag: '经典', tagColor: 'bg-accent-500' },
  { id: 'rk-3', rank: 3, title: '社内相亲', category: '韩漫·职场', heat: '921万', tag: 'NEW', tagColor: 'bg-primary-500' },
  { id: 'rk-4', rank: 4, title: '一人之下', category: '国漫·异能', heat: '887万', tag: '热门', tagColor: 'bg-accent-500' },
  { id: 'rk-5', rank: 5, title: '女神降临', category: '韩漫·校园', heat: '854万', tag: 'HOT', tagColor: 'bg-primary-500' },
  { id: 'rk-6', rank: 6, title: '狐妖小红娘', category: '国漫·玄幻', heat: '821万', tag: '经典', tagColor: 'bg-accent-500' },
  { id: 'rk-7', rank: 7, title: '全职高手', category: '国漫·电竞', heat: '798万', tag: '推荐', tagColor: 'bg-secondary-500' },
];

export const updatesItems = [
  { id: 'upd-1', date: '2026.07.28', title: '《再婚皇后》全集已更新至第138话完结篇', type: '完结入库', typeColor: 'bg-primary-100 text-primary-700' },
  { id: 'upd-2', date: '2026.07.27', title: '《剑来》动画联动特别篇全集上线', type: '特别收录', typeColor: 'bg-accent-100 text-accent-700' },
  { id: 'upd-3', date: '2026.07.26', title: '本月韩漫完结季活动正式开启，百部作品一次收齐', type: '活动公告', typeColor: 'bg-secondary-100 text-secondary-700' },
  { id: 'upd-4', date: '2026.07.25', title: '《某天成为公主》全集资源全面升级高清版本', type: '画质升级', typeColor: 'bg-primary-100 text-primary-700' },
  { id: 'upd-5', date: '2026.07.24', title: '《镖人》全集正式入库，许先哲力作不容错过', type: '新作入库', typeColor: 'bg-accent-100 text-accent-700' },
  { id: 'upd-6', date: '2026.07.23', title: '夏季阅读挑战赛上线，读满10部赢限定周边', type: '活动公告', typeColor: 'bg-secondary-100 text-secondary-700' },
  { id: 'upd-7', date: '2026.07.22', title: '《我独自升级》全集汉化版正式开放免费阅读', type: '新作入库', typeColor: 'bg-accent-100 text-accent-700' },
];

export const topicsItems = [
  { id: 'tp-1', name: '韩漫完结', count: '3280部', icon: 'ri-chat-smile-2-fill' },
  { id: 'tp-2', name: '国漫崛起', count: '2560部', icon: 'ri-global-fill' },
  { id: 'tp-3', name: '日漫经典', count: '4520部', icon: 'ri-flower-fill' },
  { id: 'tp-4', name: '下拉畅读', count: '全站支持', icon: 'ri-arrow-down-fill' },
  { id: 'tp-5', name: '恋爱甜宠', count: '2150部', icon: 'ri-heart-2-fill' },
  { id: 'tp-6', name: '热血冒险', count: '1890部', icon: 'ri-fire-fill' },
  { id: 'tp-7', name: '悬疑推理', count: '960部', icon: 'ri-eye-2-fill' },
  { id: 'tp-8', name: '古风言情', count: '1430部', icon: 'ri-pen-nib-fill' },
  { id: 'tp-9', name: '每日更新', count: '50+话', icon: 'ri-flashlight-fill' },
];

export const cardsItems = [
  {
    id: 'card-1',
    title: '再婚皇后',
    subtitle: '韩漫完结 · 古风宫廷',
    desc: '一朝入宫为后，却遭遇帝王冷落。她选择不再隐忍，步步为营夺回属于自己的一切。宫斗权谋与深情虐恋交织，138话全集已完结。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20historical%20romance%20manhwa%20cover%20featuring%20an%20elegant%20queen%20in%20traditional%20hanbok%20standing%20in%20a%20palace%20courtyard%20with%20cherry%20blossoms%20falling%20soft%20warm%20lighting%20regal%20and%20romantic%20atmosphere%20delicate%20art%20style%20professional%20illustration&width=500&height=350&seq=manga-card-01&orientation=landscape',
    tag: '完结',
    tagColor: 'bg-primary-500',
    stats: ['138话', '9.6分', '982万阅读'],
  },
  {
    id: 'card-2',
    title: '斗罗大陆',
    subtitle: '国漫经典 · 玄幻热血',
    desc: '唐门外门弟子唐三，因偷学内门绝学而为唐门所不容。跳崖明志后穿越至斗罗大陆，以武魂重新踏上强者之路。国漫传奇之作。',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20Chinese%20fantasy%20manhua%20cover%20featuring%20a%20powerful%20martial%20artist%20with%20glowing%20spirit%20rings%20surrounded%20by%20mystical%20energy%20in%20a%20grand%20fantasy%20landscape%20vibrant%20blue%20and%20gold%20color%20palette%20dramatic%20composition%20professional%20illustration&width=500&height=350&seq=manga-card-02&orientation=landscape',
    tag: '经典',
    tagColor: 'bg-accent-500',
    stats: ['336话', '9.8分', '956万阅读'],
  },
  {
    id: 'card-3',
    title: '我独自升级',
    subtitle: '韩漫完结 · 奇幻战斗',
    desc: '最低等级的猎人成振宇，在生死关头获得了"系统"的力量，从此踏上了独一无二的升级之路。燃到极致的战斗场面，全程高能无尿点。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20manhwa%20cover%20featuring%20a%20powerful%20hunter%20character%20with%20glowing%20eyes%20and%20dark%20energy%20aura%20standing%20in%20a%20dungeon%20gate%20scene%20dramatic%20lighting%20and%20atmospheric%20shadows%20intense%20and%20cool%20vibe%20professional%20Korean%20webtoon%20art&width=500&height=350&seq=manga-card-03&orientation=landscape',
    tag: 'HOT',
    tagColor: 'bg-primary-500',
    stats: ['179话', '9.7分', '865万阅读'],
  },
  {
    id: 'card-4',
    title: '一人之下',
    subtitle: '国漫精品 · 都市异能',
    desc: '普通大学生张楚岚卷入异人世界的纷争，从此开启了一段惊心动魄的冒险。道家文化、现代都市与超能力量完美融合，国漫必看之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20modern%20Chinese%20manhua%20cover%20with%20a%20cool%20urban%20character%20using%20supernatural%20powers%20in%20a%20city%20night%20scene%20neon%20lights%20and%20traditional%20taoist%20elements%20blended%20together%20dynamic%20composition%20vibrant%20warm%20colors%20professional%20illustration&width=500&height=350&seq=manga-card-04&orientation=landscape',
    tag: '精品',
    tagColor: 'bg-accent-500',
    stats: ['609话', '9.5分', '887万阅读'],
  },
  {
    id: 'card-5',
    title: '女神降临',
    subtitle: '韩漫完结 · 校园恋爱',
    desc: '通过化妆逆袭的丑小鸭变天鹅故事，甜蜜又搞笑的校园恋爱喜剧。三位主角的三角关系令人揪心，画风精美绝伦，每一帧都是壁纸。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20webtoon%20cover%20featuring%20a%20stunning%20female%20character%20with%20flawless%20makeup%20in%20a%20school%20setting%20soft%20cherry%20blossom%20petals%20floating%20around%20warm%20pink%20and%20cream%20color%20palette%20dreamy%20romantic%20atmosphere%20professional%20manhwa%20art&width=500&height=350&seq=manga-card-05&orientation=landscape',
    tag: '甜宠',
    tagColor: 'bg-primary-500',
    stats: ['260话', '9.4分', '854万阅读'],
  },
];

export const commentsItems = [
  {
    id: 'cmt-1',
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20cartoon%20avatar%20of%20a%20young%20person%20with%20warm%20smile%20minimal%20style%20soft%20coral%20and%20cream%20colors%20clean%20background&width=80&height=80&seq=manga-avatar-01&orientation=squarish',
    date: '3天前',
    content: '之前追《再婚皇后》每周等一话真的要命，没想到咻咻漫画直接上全集！一口气刷完138话，太过瘾了！下拉式阅读体验真的绝，比翻页舒服太多了。',
    rating: 5,
    badge: '资深读者',
  },
  {
    id: 'cmt-2',
    name: '阿琳爱看漫',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20cartoon%20avatar%20of%20a%20girl%20with%20glasses%20reading%20a%20book%20minimal%20style%20warm%20amber%20and%20cream%20colors%20clean%20background&width=80&height=80&seq=manga-avatar-02&orientation=squarish',
    date: '5天前',
    content: '韩漫全集真的太香了！以前到处找资源，现在一个网站全搞定。而且全部免费，画质也很清晰。已经安利给身边所有追漫的朋友了！',
    rating: 5,
    badge: '韩漫爱好者',
  },
  {
    id: 'cmt-3',
    name: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20cartoon%20avatar%20of%20a%20person%20with%20headphones%20minimal%20style%20warm%20peach%20and%20cream%20colors%20clean%20background&width=80&height=80&seq=manga-avatar-03&orientation=squarish',
    date: '1周前',
    content: 'APP的夜间模式太适合我了，每天晚上躺床上刷几话，下拉阅读比翻页自然多了，不知不觉就看到凌晨。国漫专区也做得不错，一人之下全集收藏了！',
    rating: 4,
    badge: '夜猫子读者',
  },
  {
    id: 'cmt-4',
    name: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20cute%20cartoon%20avatar%20of%20a%20person%20with%20a%20cap%20minimal%20style%20warm%20coral%20and%20cream%20colors%20clean%20background&width=80&height=80&seq=manga-avatar-04&orientation=squarish',
    date: '2周前',
    content: '作为一个看了十几年漫画的老读者，咻咻漫画的资源量真的让我惊喜。很多绝版老漫都能找到全集，冷门佳作推荐板块也很有品位，发现了好几部宝藏作品。',
    rating: 5,
    badge: '十年漫龄',
  },
];

export const contactData = {
  title: '联系我们',
  subtitle: '有推荐作品？发现资源缺失？欢迎随时与我们联系',
  desc: '咻咻漫画持续扩充漫画资源库，如果你有希望收录的完结漫画作品，或者在使用过程中遇到任何问题，都可以通过以下方式联系我们。读者反馈是我们不断进步的动力。',
  email: 'contact@xiuxiumanga.com',
  wechat: 'xiuxiu_manga',
  qq: '800123456',
  items: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'submit@xiuxiumanga.com' },
    { icon: 'ri-wechat-line', label: '微信公众号', value: '咻咻漫画' },
    { icon: 'ri-qq-line', label: 'QQ读者群', value: '88201563' },
    { icon: 'ri-question-answer-line', label: '在线反馈', value: '点击提交问题' },
  ],
};

export const featuresItems = [
  {
    id: 'feat-1',
    icon: 'ri-stack-fill',
    title: '全集免费',
    desc: '17000+部完结漫画全免费，韩漫国漫日漫一网打尽，打开即看，告别追更焦虑。',
  },
  {
    id: 'feat-2',
    icon: 'ri-smartphone-fill',
    title: '多端同步',
    desc: '手机、平板、电脑无缝切换，阅读进度自动云同步，随时随地继续精彩故事。',
  },
  {
    id: 'feat-3',
    icon: 'ri-shield-check-fill',
    title: '正版高清',
    desc: '全部漫画采用正版高清源，画面清晰锐利，配合CDN加速技术确保流畅加载。',
  },
];

export const navLinks = [
  { label: '热门话题', anchor: '#topics' },
  { label: '常见问题', anchor: '#faq' },
  { label: '联系我们', anchor: '#contact' },
  { label: '更新快讯', anchor: '#updates' },
  { label: '关于我们', anchor: '#about' },
  { label: '精选专题', anchor: '#carousel' },
];